import type { Cast } from '../../type/common/types';
export const castToRequiredType = (cast: Cast, answers: string | string[]): string | number | boolean | string[] => {
  if (Array.isArray(answers)) {
    return answers;
  }
  switch (cast) {
    case 'BOOLEAN':
      {
        return Boolean(answers);
      }
    case 'NUMBER':
      {
        return Number(answers);
      }
    case 'STRING':
    case 'STRING_LIST':
      {
        return answers;
      }
    default:
      {
        (cast satisfies never);
        return answers;
      }
  }
};